import dayjs from "dayjs";

// let lastDisplayedDate = null;
const signalHistory = {
  dataZoom: [
    {
      type: "slider",
      start: 0,
      end: 100,
      show: true,
      showDetail: false,
    },
  ],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  grid: {
    left: 60,
    top: 60,
    right: 20,
    bottom: 100,
  },
  legend: {
    data: ["Signal Strength"],
    left: "center",
    icon: "roundRect",
  },
  xAxis: [
    {
      type: "time",
      name: "Time",
      nameGap: 40,
      nameLocation: "middle",
      boundaryGap: false,
      axisPointer: {
        label: {
          formatter: function (params) {
            return dayjs(params.value).format("MM-DD-YYYY HH:mm:ss");
          },
        },
        handle: {
          show: false,
        },
      },
      axisLabel: {
        formatter: function (value) {
          const date = new Date(value);
          const formattedDate = `${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${date
            .getDate()
            .toString()
            .padStart(2, "0")}/${date.getFullYear()}`;

          // if (formattedDate === lastDisplayedDate) {
          //   return "";
          // }
          // lastDisplayedDate = formattedDate;
          return formattedDate;
        },
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "Signal Strength",
      nameGap: 40,
      nameRotate: 90,
      nameLocation: "middle",
    },
  ],
  series: [
    {
      name: "Signal Strength",
      type: "line",
      data: [],
      symbol: "none",
      itemStyle: {
        color: "#FF8027",
      },
      lineStyle: {
        normal: {
          width: 4,
          type: "solid",
        },
      },
    },
  ],
};

export default signalHistory;
